import { eDmKhoaActionsObj } from "../../action-types/category/IDmKhoaActions";
import { generateActions } from "../generateActions";

export const khoaActions = {
  ...generateActions(eDmKhoaActionsObj, "KHOA"),
};
